module.exports = __webpack_public_path__ + "static/media/spotme.f6b3fcd1.mov";